import script from "./textarea-setting-ly.vue?vue&type=script&setup=true&lang=js"
export * from "./textarea-setting-ly.vue?vue&type=script&setup=true&lang=js"

import "./textarea-setting-ly.vue?vue&type=style&index=0&id=64a63e44&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64a63e44"]])

export default __exports__